import SigninPage from './SignInPage.container'

export default SigninPage
